import STORE from '../store/store';

export function callbackHandler(API, res, callback,noDate) {
    const RES = res.data
    const DATA = (RES && RES.data) ? RES.data : {};
    if (RES.code * 1 == 1 ) {
        if (typeof callback == 'function') {
            if (noDate) {
                callback(RES);
            }else{
                callback(DATA);
            }
        }
    } else if (RES.code * 1 == 302) {
        console.log(RES.code)
        location.href = RES.data;
    } else {
        // 全都是异常情况，先把loading藏起来
        STORE.commit('setLOADINGTEXT', '');

        if (RES.code * 1 == 0) {
            window.monitor.stat({
                level: 'error',
                error: 'API-data',
                msg: '请求接口失败',
                url: API,
            });
            setTimeout(() => {
                STORE.commit('setTOASTTEXT', '接口请求失败');
            }, 1000)

        } else if (RES.code * 1 == 2001) {
            if (typeof callback == 'function') {
                // 购买测评，有已完成订单，进行弹框提示
                callback(DATA, 2001);
            }
        } else if (RES.code * 1 == 5000) {
            window.monitor.stat({
                level: 'error',
                error: 'API-data',
                msg: '服务器内部错误',
                url: API,
            });
            setTimeout(() => {
                STORE.commit('setTOASTTEXT', '接口请求失败');
            }, 1000)

        } else if (RES.code * 1 == 5001) {
            window.monitor.stat({
                level: 'error',
                error: 'API-data',
                msg: '用户未登录',
                url: API,
            });
        } else if (RES.code * 1 == 5003) {
            window.monitor.stat({
                level: 'error',
                error: 'API-data',
                msg: '服务超时',
                url: API,
            });
        } else if (RES.code * 1 == 40001) {
            window.monitor.stat({
                level: 'error',
                msg: '请求参数中没有签名',
                error: 'API-data',
                url: API,
            });
        } else if (RES.code * 1 == 40002) {
            window.monitor.stat({
                level: 'error',
                msg: '签名错误',
                error: 'API-data',
                url: API,
            });
        } else if (RES.code * 1 == 40003) {
            window.monitor.stat({
                level: 'error',
                msg: '接口传参 错误(没有传对应的接口参数)',
                error: 'API-data',
                url: API,
            });
        } else if (RES.code * 1 == 40004) {
            window.monitor.stat({
                level: 'error',
                msg: '企业没有密钥错误',
                error: 'API-data',
                url: API,
            });
        } else if (RES.code * 1 == 40005) {
            window.monitor.stat({
                msg: '企业不存在',
                error: 'API-data',
                url: API,
            });
        } else if (RES.code * 1 == 40006) {
            window.monitor.stat({
                level: 'error',
                msg: '请求数据size太长',
                error: 'API-data',
                url: API,
            });
        } else if (RES.code * 1 == 40007) {
            window.monitor.stat({
                level: 'error',
                msg: '请求参数不合法',
                error: 'API-data',
                url: API,
            });
        } else {
            window.monitor.stat({
                level: 'info',
                msg: `接口请求成功，状态code=${RES.code}`,
                error: 'API-data',
                url: API,
            });

            if (typeof callback == 'function') {
                callback(DATA ? DATA : RES.msg, RES.code);
            }
        }
    }
    return RES;
}

export function YIAPIcallbackHandler(API, res, callback,noDate) {
    const RES = res.data,
        DATA = RES.data ? RES.data : {}
    if (RES.code * 1 == 0) {
        if (typeof callback == 'function') {
            if (noDate) {
                callback(RES)
            } else{
                callback(DATA)
            }
        }
    } else {
        // 全都是异常情况，先把loading藏起来
        STORE.commit('setLOADINGTEXT', '')

        if (RES.code * 1 == 1) {
            window.monitor.stat({
                level: 'error',
                error: 'API-data',
                msg: '请求接口失败',
                url: API,
            });
            setTimeout(() => {
               STORE.commit('setTOASTTEXT', `${RES.message}`);
            }, 1000)

        } else {
            window.monitor.stat({
                level: 'info',
                msg: `接口请求成功，状态code=${RES.code}`,
                error: 'API-data',
                url: API,
            });

            if (typeof callback == 'function') {
                callback(DATA ? DATA : RES.msg, RES.code)
            }
        }
    }
    return RES
}

export default {
    callbackHandler,
}





// WEBPACK FOOTER //
// ./src/store/callbackHandler.js